export default "./media/marker_deactivated-dc7053516b18fcc218dd392a687ebf66.png";